// Auto-generated by scripts/generate-version.js — do not edit
export const BUILD_HASH = "487af59d247a";
export const BUILD_VERSION_NUMBER = 59;
